import { Button, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CombinedIngredient from "../../components/CombinedIngredient";
import Ingredient from "../../components/Ingredient";
import {
  EDIT_LIST,
  REMOVE_LIST,
  SET_LIST_CHECKED,
} from "../../constants/reducerEvents";
import { getCombinedList } from "../../utils/shopping.utils";

export default function ListPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [showCombined, setShoeCombined] = useState(false);
  const list = useSelector((state) =>
    state.lists.find((l) => `${l.id}` === id)
  );
  const checked = list?.checked;
  const [combinedList, setCombinedList] = useState([]);
  useEffect(() => {
    setCombinedList(getCombinedList(list));
  }, [list]);
  const setChecked = (checkedList) => {
    dispatch({ type: SET_LIST_CHECKED, payload: { id, checked: checkedList } });
  };
  const toggleChecked = (ing) => {
    if (checked.includes(ing)) {
      setChecked(checked.filter((t) => t !== ing));
    } else {
      setChecked([...checked, ing]);
    }
  };
  const toggleCombined = (combined) => {
    const isChecked = !combined.sources.some(
      (source, i) =>
        !checked.includes(`${source.name}-${combined.originals[i]}`)
    );
    let newChecked = [];
    if (isChecked) {
      newChecked = checked.filter(
        (c) =>
          !combined.sources.some(
            (s, i) => c === `${s.name}-${combined.originals[i]}`
          )
      );
    } else {
      newChecked = [
        ...new Set([
          ...checked,
          ...combined.sources.map(
            (s, i) => `${s.name}-${combined.originals[i]}`
          ),
        ]),
      ];
    }
    setChecked(newChecked);
    // console.log(combined, isChecked);
    // `${recipe.recipe.name}-${recipe.recipe.recipeIngredients[i]}`;
  };
  const deleteList = () => {
    dispatch({ type: REMOVE_LIST, payload: id });
    navigate("/lists");
  };
  const editList = () => {
    dispatch({ type: EDIT_LIST, payload: list });
    navigate("/shopping");
  };
  const [removeChecked, setRemoveChecked] = useState(false);
  return (
    <div>
      {list ? (
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", right: 0 }}>
            <Button onClick={editList}>Edit</Button>
            <Button color="error" onClick={deleteList}>
              Delete
            </Button>
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "25px",
              fontWeight: "500",
            }}
          >
            {list.name}
          </div>
          <div style={{ display: "flex" }}>
            <Switch
              value={removeChecked}
              onChange={() => setRemoveChecked((r) => !r)}
            />
            <div style={{ paddingTop: "8px" }}>Remove Checked</div>
          </div>
          <div style={{ display: "flex" }}>
            <Switch
              value={showCombined}
              onChange={() => setShoeCombined((r) => !r)}
            />
            <div style={{ paddingTop: "8px" }}>Combine Lists</div>
          </div>
          <div style={{ padding: "10px" }}>
            <div style={{ fontSize: "18px", fontWeight: "500" }}>
              Extra Items:
            </div>
            {list.extraIngredients.map(
              (ing, i) =>
                (!removeChecked || !checked.includes(`extra-${ing}`)) && (
                  <Ingredient
                    name={ing}
                    checked={checked.includes(`extra-${ing}`)}
                    id={i}
                    onClick={() => toggleChecked(`extra-${ing}`)}
                  />
                )
            )}
          </div>

          {showCombined ? (
            <div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  paddingLeft: "10px",
                }}
              >
                Recipe Items:
              </div>
              {combinedList
                .filter(
                  (c) =>
                    c.checked.some((t) => !t) &&
                    (!removeChecked ||
                      c.sources.some(
                        (source, i) =>
                          !checked.includes(`${source.name}-${c.originals[i]}`)
                      ))
                )
                .map((c) => (
                  <CombinedIngredient
                    ingredient={c}
                    onClick={toggleCombined}
                    isChecked={
                      !c.sources.some(
                        (source, i) =>
                          !checked.includes(`${source.name}-${c.originals[i]}`)
                      )
                    }
                  />
                ))}
            </div>
          ) : (
            <div>
              {list.selected.map((recipe) => (
                <div style={{ padding: "10px" }}>
                  <div style={{ fontSize: "18px", fontWeight: "500" }}>
                    {`${recipe.recipe.name} (${
                      Math.round(
                        (100 * recipe.quantity) /
                          parseInt(recipe.recipe.recipeYield)
                      ) / 100
                    }x)`}
                  </div>
                  {recipe.ingredients.map(
                    (hasIng, i) =>
                      !hasIng &&
                      (!removeChecked ||
                        !checked.includes(
                          `${recipe.recipe.name}-${recipe.recipe.recipeIngredients[i]}`
                        )) && (
                        <Ingredient
                          name={recipe.recipe.recipeIngredients[i]}
                          checked={checked.includes(
                            `${recipe.recipe.name}-${recipe.recipe.recipeIngredients[i]}`
                          )}
                          onClick={() =>
                            toggleChecked(
                              `${recipe.recipe.name}-${recipe.recipe.recipeIngredients[i]}`
                            )
                          }
                        />
                      )
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div>List Not Found</div>
      )}
    </div>
  );
}
